import { type UseQueryResult, useQuery } from 'react-query';
import { BrandingPackageQueryService } from '@wealthlane/api-services/wealthlane-customer-service';

const useGetBrandingPackageAssignmentOptions = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string | null | undefined;
      value: string | undefined;
    }>
  | undefined,
  unknown
> => {
  const brandingPackageOptions = useQuery(
    ['getBrandingPackageAssignmentOptions'],
    async () => {
      return await handleRequest(
        BrandingPackageQueryService.getApiCustomerApiBrandingPackageAssignmentOptions()
      );
    },
    {
      select(data) {
        return data?.map((item) => {
          return {
            label: item.packName,
            value: item.id,
          };
        });
      },
    }
  );

  return brandingPackageOptions;
};

export default useGetBrandingPackageAssignmentOptions;
